import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    contenteditable: "true",
    ref: "editableTextEl",
    onKeydown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onOrderNumberKeyup && _ctx.onOrderNumberKeyup(...args))),
    onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onOrderNumberKeyup && _ctx.onOrderNumberKeyup(...args))),
    onPaste: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onOrderNumberPaste && _ctx.onOrderNumberPaste(...args))),
    class: "editable"
  }, null, 544))
}